import type { GeneratedItem, ItemCategory, ItemId, ItemMeta, TextureId } from '@/types/domain';
import { textureCatalog } from '@/engine/TextureCatalog';
import { itemRegistry } from '@/engine/VanillaItemRegistry';

export function generatedToMeta(item: GeneratedItem): ItemMeta {
  const kind: ItemMeta['kind'] =
    item.isMachine || item.category === 'machine' || item.category === 'redstone'
      ? 'utility'
      : item.category === 'block' || item.category === 'decorative' || item.category === 'structure'
        ? 'block'
        : 'item';
  return {
    id: item.id,
    name: item.name,
    textureId: item.textureId,
    category: item.category as ItemCategory,
    tags: item.tags,
    material: undefined,
    toolType: item.tags.find((t) => ['pickaxe', 'axe', 'shovel', 'hoe', 'sword', 'bow', 'fishing_rod'].includes(t)),
    blockType: undefined,
    purpose: item.functionalTraits[0] || item.category,
    aliases: [],
    obtainable: true,
    kind,
    tier: item.tier,
    rarity: item.rarity,
  };
}

export function resolveMeta(id: ItemId): ItemMeta | undefined {
  if (id.startsWith('custom:')) {
    const meta = itemRegistry.get(id);
    return meta;
  }
  return itemRegistry.get(id);
}

export function textureUrl(id: TextureId): string | undefined {
  return textureCatalog.urlFor(id);
}
